import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { FiTooltipButtonIconColors } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.component';
import { IConditionSummaryResult, IFormCondition, IFormQuestion } from '@fi-shared/fi-form-shared/fi-form-shared';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormConditionHelperService } from '@fi-shared/fi-form-shared/fi-form-condition-helper.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { isDefined } from '@fi-shared/utils';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-form-logic-condition-list-item',
    templateUrl: './fi-form-logic-condition-list-item.component.html',
    styleUrls: ['./fi-form-logic-condition-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-logic-condition-list-item' },
    standalone: false,
})
export class FiFormLogicConditionListItemComponent implements OnInit, OnChanges, OnDestroy {
    @Input() conditionNumber: string;
    @Output() onRemoveCondition = new EventEmitter<void>();
    @Output() onEditCondition = new EventEmitter<void>();
    @Input() condition: IFormCondition;
    @Input() formQuestions: IFormQuestion[] = [];
    @Input() selectedLanguageId: number;

    FiTooltipButtonIconColors = FiTooltipButtonIconColors;
    isConditionComplete$ = new BehaviorSubject<boolean>(true);
    conditionSummary: string;

    constructor(
        private appTextService: AppTextService,
        private formHelperService: FiFormHelperService,
        private formConditionHelperService: FiFormConditionHelperService,
    ) {}

    ngOnInit(): void {
        this.formHelperService.deleteQuestionEvent$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.getConditionSummary();
        });
        this.formHelperService.deleteQuestionPresetOptionEvent$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.getConditionSummary();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.selectedLanguageId;
        if (change && isDefined(change.currentValue)) {
            this.getConditionSummary();
        }
    }

    private getConditionSummary() {
        const result: IConditionSummaryResult = this.formConditionHelperService.getConditionSummaryHTML(
            this.condition,
            this.formQuestions,
            this.selectedLanguageId,
        );
        this.conditionSummary = result.message;
        this.isConditionComplete$.next(result.isComplete);
    }

    removeCondition() {
        this.onRemoveCondition.emit();
    }

    editCondition() {
        this.onEditCondition.emit();
    }

    getConditionSummaryText(conditionDescriptionContainer: HTMLElement): string {
        return conditionDescriptionContainer.textContent;
    }

    isConditionTooltipShown(conditionDescriptionContainer: HTMLElement): boolean {
        return conditionDescriptionContainer.scrollHeight > conditionDescriptionContainer.clientHeight;
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
